<script>
  import { Spinner } from '@client/components/spinner';

  export let show = false;
  export let content = '';
  export let url = null;
  export let disableZoom = false;
  export let minHeight = 'auto';
  export let minWidth = '320px';
  export let frameMinHeight = 'auto';
  export let frameMinWidth = 'auto';

  let containerRef = null;
  let iframeLoaded = false;
  let adjustX = false;
  let adjustY = false;
  let zoomValue = disableZoom ? '1' : '.5';

  const positionPreview = (element) => {
    if (!element) {
      adjustX = false;
      adjustY = false;
      return;
    }

    const rect = element.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    adjustX = rect.right > viewportWidth;
    adjustY = rect.bottom > viewportHeight;
  };

  const onIframeLoad = function (e, inlineContent = false) {
    const iframe = e.target;
    const zoomLevel = inlineContent && disableZoom ? 1 : 2;

    iframe.style.visibility = 'visible';
    iframe.style.opacity = 1;

    if (!url) {
      iframe.style.height = (iframe.contentWindow.document.body.firstChild.clientHeight + 20) / zoomLevel + 'px';
      iframe.style.width = (iframe.contentWindow.document.body.firstChild.clientWidth + 20) / zoomLevel + 'px';
    } else {
      try {
        const doc = iframe.contentWindow?.document;

        if (doc) {
          iframe.style.height = doc.body.scrollHeight + 20 + 'px';
          iframe.style.width = doc.body.scrollWidth + 20 + 'px';

          console.log('Iframe loaded:', iframe.style.height, iframe.style.width);
        }
      } catch (e) {
        console.error('Error resizing iframe:', e);
      }
    }

    iframeLoaded = true;
  };

  const showPreview = () => {
    iframeLoaded = false;

    if (!containerRef) {
      return;
    }

    positionPreview(containerRef);
  };

  $: if (!show) {
    adjustX = false;
    adjustY = false;
  }

  $: if (show) {
    setTimeout(showPreview, 0);
  }
</script>

{#if show}
  <div
    bind:this={containerRef}
    class="preview"
    class:adjust-x={adjustX}
    class:adjust-y={adjustY}
    style="min-width: {minWidth}; min-height: {minHeight};"
  >
    {#if content && !url}
      <iframe
        tabindex="-1"
        style="width: 100%; opacity: 0; visibility: hidden;"
        scrolling="no"
        title="preview"
        on:load={(e) => onIframeLoad(e, true)}
        srcdoc="<html><body style='zoom: {zoomValue}; -ms-zoom: {zoomValue}; -webkit-zoom: {zoomValue}; -moz-transform: scale({zoomValue},{zoomValue}); -moz-transform-origin: left top;'><div style='display: inline-block;'>{content}</div></body></html>"
      />
    {:else}
      <iframe
        tabindex="-1"
        style="width: 100%; opacity: 0; visibility: hidden; zoom: {zoomValue}; -ms-zoom: {zoomValue}; -webkit-zoom: {zoomValue}; min-width: {frameMinWidth}; min-height: {frameMinHeight};"
        scrolling="no"
        title="preview"
        src={url}
        sandbox="allow-scripts"
        on:load={(e) => onIframeLoad(e)}
      />
    {/if}

    {#if !iframeLoaded}
      <Spinner show />
    {/if}
  </div>
{/if}

<style lang="scss" src="./preview.scss"></style>
